export interface Article {
  id: string;
  title: string;
  category: 'cp' | 'daily' | 'character';
  categoryLabel: string;
  excerpt: string;
  cover: string;
  date: string;
  author: string;
  readTime: string;
  tags: string[];
  content: string[];
  relatedIds: string[];
}

export const articles: Article[] = [
  {
    id: 'lingxiu-timeline',
    title: '灵秀CP发展时间线：从兄妹到道侣的全梳理',
    category: 'cp',
    categoryLabel: 'CP考据',
    excerpt: '李长寿与蓝灵娥这条感情线，如何从「十年教导」的兄妹情一步步走到「一生相守」？我们按剧情脉络为你逐段复盘。',
    cover: 'https://readdy.ai/api/search-image?query=Traditional%20Chinese%20ink-wash%20painting%20of%20a%20young%20cultivator%20couple%20standing%20side%20by%20side%20on%20a%20mountain%20peak%20among%20clouds%20at%20sunset%2C%20warm%20cinnabar%20red%20and%20golden%20tones%20on%20warm%20paper%20background%2C%20elegant%20wuxia%20cultivation%20aesthetic%2C%20romantic%20soft%20lighting%2C%20high%20detail%2C%20no%20text&width=800&height=500&seq=art-lingxiu&orientation=landscape',
    date: '2026-08-12',
    author: '考据君阿青',
    readTime: '8分钟',
    tags: ['灵秀', '时间线', '官配'],
    content: [
      '要说《师兄啊师兄》里最让人放不下的感情线，一定绕不开李长寿与蓝灵娥这对「灵秀师兄妹」。这条线最动人的地方，恰恰在于它没有天降奇缘，只有日积月累的十年。',
      '故事的开端，不过是一次寻常的入门。蓝灵娥初入度仙门，柔柔弱弱，什么都不懂。而李长寿那时已打定主意低调行事，却偏偏对这个师妹多看了几眼。命运就在这里悄悄系上了线。',
      '往后的日子，是数不清的晨课与夜谈。师兄演练法术，师妹在旁偷学；师妹遇到难关，师兄总能恰好出现。看似随意的每一句「师兄」，其实都藏着日复一日的依赖与信任。',
      '真正的转折，出现在生死关头的考验里。向来把「稳健」挂在嘴边的李长寿，第一次破例动用了压箱底的手段，只为护她周全。那场戏里没有一句直白的告白，却让无数观众瞬间破防。',
      '从兄妹到道侣，从教导到相守。这条线的动人之处，在于它从不喧哗，却把「陪伴是最长情的告白」演到了极致。云海之间并肩而立的那一刻，便是最好的答案。',
    ],
    relatedIds: ['jiuzu-moments', 'xiongwen-daily'],
  },
  {
    id: 'jiuzu-moments',
    title: '叔侄向名场面盘点：酒玖 × 李长寿的反差萌',
    category: 'cp',
    categoryLabel: 'CP考据',
    excerpt: '又飒又沙雕的酒玖师叔，到底贡献了多少「叔侄」名场面？喝酒、斗嘴、护短，全程高能。',
    cover: 'https://readdy.ai/api/search-image?query=Traditional%20Chinese%20ink-wash%20painting%20of%20an%20elegant%20woman%20cultivator%20drinking%20wine%20from%20a%20gourd%20while%20laughing%20with%20a%20young%20male%20cultivator%2C%20playful%20mood%2C%20cinnabar%20red%20and%20ink%20tones%20on%20warm%20paper%20background%2C%20elegant%20wuxia%20cultivation%20aesthetic%2C%20soft%20lighting%2C%20high%20detail%2C%20no%20text&width=800&height=500&seq=art-jiuzu&orientation=landscape',
    date: '2026-08-09',
    author: '吃瓜不吐核',
    readTime: '6分钟',
    tags: ['酒玖', '叔侄向', '名场面'],
    content: [
      '如果要给「酒玖 × 李长寿」这条线贴标签，最贴切的一定是「反差萌」。一个自称长辈的师叔，一个满腹算计的晚辈，凑在一起就是行走的快乐源泉。',
      '酒玖的第一次登场就很「破天峰」——拎着酒壶不请自来，张口就是一句「小长寿」。明明按辈分是长辈，却偏偏没个长辈的样子，把「又飒又沙雕」贯彻到底。',
      '两人的日常就是一场大型斗嘴现场。师兄嘴上嫌弃师叔醉醺醺，转身又默默接住站不稳的她；师叔一边吐槽师兄老谋深算，一边在危难时刻收起玩闹、认真护人。',
      '这种「嘴上互相拆台、心里互相挂念」的关系，正是这条线最戳人的地方。它不轰轰烈烈，却格外真实，让人忍不住一遍遍回看。',
    ],
    relatedIds: ['lingxiu-timeline', 'shimen-feast'],
  },
  {
    id: 'shimen-feast',
    title: '破天峰酒会：酒玖师叔的酒与真心',
    category: 'daily',
    categoryLabel: '师门日常',
    excerpt: '一场破天峰的酒会，藏着多少同门情谊与意想不到的真心？我们带你回看这场高甜日常。',
    cover: 'https://readdy.ai/api/search-image?query=Traditional%20Chinese%20ink-wash%20painting%20of%20a%20warm%20feast%20among%20cultivators%20on%20a%20mountain%20terrace%20at%20night%20with%20wine%20jars%20and%20lanterns%2C%20cinnabar%20red%20and%20golden%20tones%20on%20warm%20paper%20background%2C%20elegant%20wuxia%20cultivation%20aesthetic%2C%20cozy%20soft%20lighting%2C%20high%20detail%2C%20no%20text&width=800&height=500&seq=art-feast&orientation=landscape',
    date: '2026-08-05',
    author: '阿青',
    readTime: '5分钟',
    tags: ['酒玖', '酒会', '日常'],
    content: [
      '师门日常最迷人的，往往不是波澜壮阔的大场面，而是那些烟火气十足的小日子。破天峰的一场酒会，就是最典型的高甜日常。',
      '酒玖师叔一招呼，同门们便三三两两聚到了山间。酒香混着晚风，灯火映着笑脸，平日里剑拔弩张的修士们，此刻也不过是一群爱闹爱笑的人。',
      '酒过三巡，平日嘴硬的人也开始掏心窝子。有人谈起修道初心，有人说起各自牵挂，也有人借着酒劲，把憋了很久的那句话说了出来。',
      '酒会散场，各自归峰。可那晚的温度，却留在了每个人心里——这大概就是「师门」二字最动人的分量。',
    ],
    relatedIds: ['xiongwen-daily', 'jiuzu-moments'],
  },
  {
    id: 'xiongwen-daily',
    title: '度仙门的一日：从晨课到夜谈的温馨日常',
    category: 'daily',
    categoryLabel: '师门日常',
    excerpt: '晨课、斗法、下山、夜谈——度仙门普普通通的一天，藏着最戳人的同门情谊。',
    cover: 'https://readdy.ai/api/search-image?query=Traditional%20Chinese%20ink-wash%20painting%20of%20a%20serene%20daoist%20sect%20courtyard%20in%20the%20morning%20with%20disciples%20practicing%20martial%20arts%2C%20bamboo%20and%20mountains%2C%20cinnabar%20red%20and%20ink%20tones%20on%20warm%20paper%20background%2C%20elegant%20wuxia%20cultivation%20aesthetic%2C%20soft%20morning%20light%2C%20high%20detail%2C%20no%20text&width=800&height=500&seq=art-daily&orientation=landscape',
    date: '2026-07-28',
    author: '青烟入画',
    readTime: '5分钟',
    tags: ['度仙门', '日常', '同门'],
    content: [
      '很多人爱《师兄啊师兄》，爱的是它的热血与算计；但真正让人留下的，往往是那些平淡到近乎琐碎的日常。',
      '清晨的度仙门，晨钟敲响，弟子们开始早课。李长寿照例一脸淡然地演算法术，蓝灵娥则在一旁认真地记着笔记。师徒几个，各有各的忙，却都在同一片屋檐下。',
      '白天是下山历练，或是同门间的切磋。输了不服气，赢了就得意，转头又勾肩搭背一起去吃碗面。江湖再远，这里永远有个「家」可以回。',
      '入夜，峰顶灯火渐起。师徒围坐，说些有的没的。师父嘴上念叨着「不成器」，眼底却藏不住笑意。这一刻，比任何惊天动地的战斗都更让人动容。',
    ],
    relatedIds: ['shimen-feast', 'qiyuan-warm'],
  },
  {
    id: 'qiyuan-warm',
    title: '护短的师父齐源：那些说不出口的牵挂',
    category: 'daily',
    categoryLabel: '师门日常',
    excerpt: '嘴上嫌弃、心里护短——齐源长老对徒弟的牵挂，是师门日常最温情的底色。',
    cover: 'https://readdy.ai/api/search-image?query=Traditional%20Chinese%20ink-wash%20painting%20of%20a%20wise%20old%20daoist%20master%20watching%20over%20young%20disciples%20from%20a%20hall%20doorway%2C%20warm%20golden%20interior%20light%2C%20cinnabar%20red%20and%20ink%20tones%20on%20warm%20paper%20background%2C%20elegant%20wuxia%20cultivation%20aesthetic%2C%20soft%20lighting%2C%20high%20detail%2C%20no%20text&width=800&height=500&seq=art-qiyuan&orientation=landscape',
    date: '2026-07-20',
    author: '阿青',
    readTime: '4分钟',
    tags: ['齐源', '师徒', '温情'],
    content: [
      '要论度仙门最「口是心非」的人，非齐源长老莫属。他总是一脸古板地数落徒弟，却在每一个看不见的角落，悄悄为徒弟撑起一片天。',
      '李长寿要下山历练，齐源嘴上说「自求多福」，转头却托人捎去护身之物。蓝灵娥修炼遇到瓶颈，他装作不经意地提点两句，怕她看出自己的上心。',
      '同门受委屈，第一个站出来的往往是他；徒弟闯了祸，背锅的也常常是他。这份「护短」，不说出口，却重逾千金。',
      '这大概就是师徒情谊最动人的样子——我们从不言爱，却把牵挂藏在每一个细节里。',
    ],
    relatedIds: ['xiongwen-daily', 'lingxiu-timeline'],
  },
  {
    id: 'wending-kao',
    title: '李长寿「稳健」人设考据：为什么大家都爱李苟圣',
    category: 'character',
    categoryLabel: '人物考据',
    excerpt: '不慕虚名、藏锋守拙——李长寿的「稳健」哲学，为何成了无数观众的真香现场？',
    cover: 'https://readdy.ai/api/search-image?query=Traditional%20Chinese%20ink-wash%20painting%20of%20a%20calm%20young%20male%20cultivator%20sitting%20by%20a%20lamp%20studying%20scrolls%20in%20a%20quiet%20study%2C%20cinnabar%20red%20and%20ink%20tones%20on%20warm%20paper%20background%2C%20elegant%20wuxia%20cultivation%20aesthetic%2C%20soft%20warm%20lighting%2C%20high%20detail%2C%20no%20text&width=800&height=500&seq=art-wending&orientation=landscape',
    date: '2026-07-15',
    author: '考据君阿青',
    readTime: '6分钟',
    tags: ['李长寿', '人设', '稳健'],
    content: [
      '在遍地「龙傲天」的修仙故事里，李长寿是个异类。他不爱出风头，不慕虚名，能不动手就不动手，被人戏称「李苟圣」。可偏偏，这样一个「苟」字当头的角色，让无数观众越看越上头。',
      '李长寿的「稳健」，不是怂，而是清醒。他深知洪荒残酷，明枪易躲、暗箭难防，与其逞一时之快，不如藏锋守拙、稳中求进。这份清醒，让他总能在别人看不懂的时候，早早布局。',
      '更难得的是，他的「苟」从不以牺牲身边人为代价。越是关键的时刻，他越会为了守护在意之人破例出手。这种「平时能苟则苟、关键时刻绝不含糊」的反差，正是人物最大的魅力。',
      '所以大家爱李苟圣，爱的不是他的算计，而是那个在乱世里依然守住道心、守住身边人的少年。',
    ],
    relatedIds: ['lingxiu-timeline', 'jianyi-road'],
  },
  {
    id: 'jianyi-road',
    title: '江湖剑意：敖乙与李长寿的知己相惜',
    category: 'cp',
    categoryLabel: 'CP考据',
    excerpt: '傲然天骄的剑修敖乙，与深藏不露的李长寿——两个「高手」从萍水相逢到并肩同行。',
    cover: 'https://readdy.ai/api/search-image?query=Traditional%20Chinese%20ink-wash%20painting%20of%20two%20sword%20cultivators%20standing%20back%20to%20back%20in%20a%20misty%20valley%2C%20one%20holding%20a%20long%20sword%2C%20cinnabar%20red%20and%20ink%20tones%20on%20warm%20paper%20background%2C%20elegant%20wuxia%20cultivation%20aesthetic%2C%20dramatic%20soft%20lighting%2C%20high%20detail%2C%20no%20text&width=800&height=500&seq=art-jianyi&orientation=landscape',
    date: '2026-07-10',
    author: '吃瓜不吐核',
    readTime: '5分钟',
    tags: ['敖乙', '知己', '剑意'],
    content: [
      '如果说李长寿与蓝灵娥是细水长流，那么他与敖乙之间，更像是一场剑与剑的对话。没有甜言蜜语，只有剑意相通、惺惺相惜。',
      '初见之时，一个满腹算计、一个傲然冷冽，谁也看不透谁。可当剑光出鞘的那一刻，彼此都读出了对方的不简单。高手过招，往往只需一眼。',
      '之后并肩闯荡，剑修在前开路，炼气士在后压阵。一个凌厉果决，一个算无遗策，配合得严丝合缝。这种棋逢对手的默契，比任何并肩都来得痛快。',
      '这条「江湖知己」线，也许没有甜甜的互动，却有着最纯粹的欣赏与信任——能在乱世中遇见一个懂自己道心的人，本就是最大的幸运。',
    ],
    relatedIds: ['wending-kao', 'shimen-feast'],
  },
];